import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs";
import { shareReplay, tap } from "rxjs/operators";
import { ApiNotificacaoService } from "./api-notificacao.service";
import { SignalRNotificacaoService } from "./signalr-notificacao.service";

@Injectable({
  providedIn: 'root'
})
export class NotificacaoDataService {
  private notificacoesSubject = new BehaviorSubject<any[]>([]);
  private connectionStateSubject = new BehaviorSubject<number>(0);
  private notificacoesCache$: Observable<any> = null;

  constructor(
    private api: ApiNotificacaoService,
    private signalRService: SignalRNotificacaoService
  ) {
    this.setupSignalRSubscriptions();
  }

  private setupSignalRSubscriptions(): void {
    // Escuta notificações do SignalR
    this.signalRService.notificacoes$.subscribe(notificacoes => {
      this.notificacoesSubject.next(notificacoes);
    });

    // Escuta estado da conexão
    this.signalRService.connectionState$.subscribe(state => {
      this.connectionStateSubject.next(state as unknown as number);
    });
  }

  public getNotificacoesEvent(): Observable<any[]> {
    return this.notificacoesSubject.asObservable();
  }

  public getNovaNotificacaoEvent(): Observable<any> {
    return this.signalRService.novaNotificacao$;
  }

  public getConnectionState(): Observable<number> {
    return this.connectionStateSubject.asObservable();
  }

  public isConnected(): boolean {
    return this.signalRService.isConnected();
  }

  public async conectarSignalR(usuarioId: string, token?: string): Promise<void> {
    return this.signalRService.conectar(usuarioId, token);
  }

  public async desconectarSignalR(): Promise<void> {
    return this.signalRService.desconectar();
  }

  public GetNotificacoes(): Observable<any> {
    return this.api.GetNotificacoes();
  }

  public GetNotificacoesPendentes(): Observable<any> {
    return this.api.GetNotificacaoPendentes();
  }

  /** Invalida o cache para que a próxima chamada a GetNotificacoes() dispare nova requisição (ex.: após marcar como lida). */
  public invalidarCacheNotificacoes(): void {
    this.notificacoesCache$ = null;
  }

  public MarcarNotificacaoComoLida(id: string): Observable<any> {
    return this.api.MarcarNotificacaoComoLida(id).pipe(
      tap(() => this.invalidarCacheNotificacoes())
    );
  }

  public MarcarTodasNotificacoesComoLida(): Observable<any> {
    return this.api.MarcarTodasNotificacoesComoLida().pipe(
      tap(() => this.invalidarCacheNotificacoes())
    );
  }

  public async verificarDisponibilidade(): Promise<boolean> {
    return this.signalRService.verificarDisponibilidade();
  }

  public CriarNotificacaoManutencao(signature: any): Observable<any> {
    return this.api.CriarNotificacaoManutencao(signature);
  }
}
